import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './contact-details.reducer';

export const ContactDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const contactDetailsEntity = useAppSelector(state => state.contactDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="contactDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.contactDetails.detail.title">ContactDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.contactDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.id}</dd>
          <dt>
            <span id="firstName">
              <Translate contentKey="tinyMedicRestApp.contactDetails.firstName">First Name</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.firstName}</dd>
          <dt>
            <span id="middleName">
              <Translate contentKey="tinyMedicRestApp.contactDetails.middleName">Middle Name</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.middleName}</dd>
          <dt>
            <span id="lastName">
              <Translate contentKey="tinyMedicRestApp.contactDetails.lastName">Last Name</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.lastName}</dd>
          <dt>
            <span id="addressLine1">
              <Translate contentKey="tinyMedicRestApp.contactDetails.addressLine1">Address Line 1</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.addressLine1}</dd>
          <dt>
            <span id="addressLine2">
              <Translate contentKey="tinyMedicRestApp.contactDetails.addressLine2">Address Line 2</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.addressLine2}</dd>
          <dt>
            <span id="city">
              <Translate contentKey="tinyMedicRestApp.contactDetails.city">City</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.city}</dd>
          <dt>
            <span id="countryCode">
              <Translate contentKey="tinyMedicRestApp.contactDetails.countryCode">Country Code</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.countryCode}</dd>
          <dt>
            <span id="stateCode">
              <Translate contentKey="tinyMedicRestApp.contactDetails.stateCode">State Code</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.stateCode}</dd>
          <dt>
            <span id="pincode">
              <Translate contentKey="tinyMedicRestApp.contactDetails.pincode">Pincode</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.pincode}</dd>
          <dt>
            <span id="contactNumber">
              <Translate contentKey="tinyMedicRestApp.contactDetails.contactNumber">Contact Number</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.contactNumber}</dd>
          <dt>
            <span id="mobileNumber">
              <Translate contentKey="tinyMedicRestApp.contactDetails.mobileNumber">Mobile Number</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.mobileNumber}</dd>
          <dt>
            <span id="faxNumber">
              <Translate contentKey="tinyMedicRestApp.contactDetails.faxNumber">Fax Number</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.faxNumber}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.contactDetails.email">Email</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.email}</dd>
          <dt>
            <span id="stayDuration">
              <Translate contentKey="tinyMedicRestApp.contactDetails.stayDuration">Stay Duration</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.stayDuration}</dd>
          <dt>
            <span id="createDtm">
              <Translate contentKey="tinyMedicRestApp.contactDetails.createDtm">Create Dtm</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.createDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.contactDetails.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.contactDetails.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.modifiedBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.contactDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.contactDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.contactDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.contactDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.contactDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.cursor}</dd>
          <dt>
            <span id="relationCodeId">
              <Translate contentKey="tinyMedicRestApp.contactDetails.relationCodeId">Relation Code Id</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.relationCodeId}</dd>
          <dt>
            <span id="latitude">
              <Translate contentKey="tinyMedicRestApp.contactDetails.latitude">Latitude</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.latitude}</dd>
          <dt>
            <span id="longitude">
              <Translate contentKey="tinyMedicRestApp.contactDetails.longitude">Longitude</Translate>
            </span>
          </dt>
          <dd>{contactDetailsEntity.longitude}</dd>
        </dl>
        <Button tag={Link} to="/contact-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/contact-details/${contactDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ContactDetailsDetail;
